var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_264",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3021 0.5H0.445068V9.495H17.3021V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47307 7.122C8.57932 7.22777 8.72314 7.28715 8.87307 7.28715C9.02299 7.28715 9.16681 7.22777 9.27307 7.122L12.7231 3.674C12.7816 3.62292 12.8291 3.56035 12.8624 3.49016C12.8958 3.41998 12.9144 3.34369 12.917 3.26602C12.9197 3.18836 12.9063 3.11098 12.8778 3.03869C12.8493 2.9664 12.8062 2.90074 12.7513 2.84579C12.6963 2.79084 12.6307 2.74777 12.5584 2.71926C12.4861 2.69075 12.4087 2.6774 12.331 2.68005C12.2534 2.68269 12.1771 2.70128 12.1069 2.73464C12.0367 2.76801 11.9742 2.81544 11.9231 2.874L9.44307 5.354C9.2906 5.50476 9.0898 5.59684 8.87607 5.614C8.66232 5.59693 8.46148 5.50483 8.30907 5.354L5.82607 2.872C5.71778 2.77754 5.57766 2.72773 5.43405 2.73262C5.29043 2.73751 5.15403 2.79675 5.05242 2.89836C4.95081 2.99997 4.89157 3.13637 4.88668 3.27998C4.88179 3.4236 4.93161 3.56371 5.02607 3.672L8.47307 7.122Z",
    fill: "#144B95",
    stroke: "#144B95",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2da185cfc268238d7205605611a6f924.svg";
export { ForwardRef as ReactComponent };